(() => {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;

  const loadRecommendations = () => {
    if (!drawer.classList.contains('active')) return;
    const slot = drawer.querySelector('[data-nxt-cart-recommendations-slot]');
    if (!slot || slot.dataset.nxtState) return;
    const productId = slot.dataset.productId;
    if (!productId) return;
    slot.dataset.nxtState = 'loading';
    const root = window.Shopify?.routes?.root || '/';
    const url = `${root}recommendations/products?section_id=nxt-cart-recommendations&product_id=${encodeURIComponent(productId)}&limit=10&intent=related`;
    fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error('recommendations_failed');
        return response.text();
      })
      .then((html) => {
        const content = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-nxt-cart-recommendations]');
        if (content?.querySelector('.nxt-cart-recommendations__card')) slot.innerHTML = content.outerHTML;
        slot.dataset.nxtState = 'loaded';
      })
      .catch(() => { slot.dataset.nxtState = 'failed'; });
  };

  new MutationObserver(loadRecommendations).observe(drawer, {
    attributes: true,
    attributeFilter: ['class'],
    childList: true,
    subtree: true,
  });
  loadRecommendations();

  drawer.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-nxt-cart-recommend-add]');
    if (!button || button.disabled) return;
    button.disabled = true;
    try {
      const response = await fetch(routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(button.closest('.nxt-cart-recommendations__card')?.querySelector('[data-nxt-cart-recommend-variant]')?.value || button.dataset.nxtCartRecommendAdd), quantity: 1 }],
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname,
        }),
      });
      const cart = await response.json();
      if (!response.ok || cart.status) throw new Error(cart.description || '追加できませんでした');
      drawer.renderContents(cart);
      drawer.classList.remove('is-empty');
      drawer.querySelector('cart-drawer-items')?.classList.remove('is-empty');
      drawer.open();
    } catch (error) {
      button.disabled = false;
      button.textContent = '再度お試しください';
    }
  });
})();
